var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 13.5998V17.1998C17.2 17.6772 17.0104 18.135 16.6728 18.4726C16.3352 18.8102 15.8774 18.9998 15.4 18.9998H2.8C2.32261 18.9998 1.86477 18.8102 1.52721 18.4726C1.18964 18.135 1 17.6772 1 17.1998V4.5998C1 4.12242 1.18964 3.66458 1.52721 3.32701C1.86477 2.98945 2.32261 2.7998 2.8 2.7998H6.4",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4499 13.42L18.9999 4.78L15.2199 1L6.6699 9.55L6.3999 13.6L10.4499 13.42Z",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ab4c1aae68110c7dab7a18eb4c893890.svg";
export { ForwardRef as ReactComponent };